<template>
  <h6>Gruppenmaßnahmen</h6>
  <div class="table-responsive overflow-auto">
    <table class="table table-striped">
      <thead>
      <tr>
        <th>Status</th>
        <th>Maßnahmenart</th>
        <th>Standort</th>
        <th>Start</th>
        <th>Ende</th>
        <th>Stand</th>
        <th>Stand %</th>
        <th>UE fehlt</th>
        <th>Coach</th>
        <th>Geva Testung</th>
        <th>Noch abzurechnende Stunden</th>
        <th>Letzter Termin</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(coaching, index) in groupCoachingList" :key="index">
        <td> {{ coaching.statusTranslated }}</td>
        <td> {{ coaching.nameOfCoaching.operationTypeTranslated }}</td>
        <td> {{ coaching.unemployed?.location?.name }}</td>
        <td> {{ coaching.startDate }} {{ coaching.startDate }}</td>
        <td> {{ coaching.endDate }}</td>
        <td> {{ coaching.unitsHeld }}</td>
        <td> {{ coaching.unitsHeldPercent }} %</td>
        <td style="text-align: center">{{ coaching.notSignedUnits }}</td>
        <td>
          <template v-for="(coach, index) in coaching.coaches" :key="index">
            {{ coach.firstName }} {{ coach.lastName }}<br/>
          </template>
        </td>
        <td style="text-align: center"> {{ coaching.gevaStatusTranslated }}</td>
        <td style="text-align: center"></td>
        <td> {{ coaching.lastUnit }}</td>
        <td>
          <router-link
              :to="{
                  name: 'analyticsUnemployedDetailsOverviewCoachingDetails',
                  params: {
                    coachingType: 'group-coaching',
                    id: coaching.id
                  }
                }"
              class="btn btn-primary">
            Analytik
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  groupCoachingList: {
    require: true,
  },
});
</script>

<style scoped>

</style>